module.exports = __webpack_public_path__ + "img/illinoisAdventure@1x.98aedaf7.png";